const PRIMARY_UUID_FIELDS = ["uuid", "neuronUuid", "neuron_item_uuid"];
const SECONDARY_STRING_FIELDS = [
  "neuronItemId",
  "itemId",
  "entityId",
  "entity_id",
  "id",
];

const normaliseStringValue = (value) => {
  if (typeof value !== "string") {
    return null;
  }

  const trimmed = value.trim();
  return trimmed || null;
};

/**
 * Attempt to resolve the Neuron item ID for a given story.
 * The API expects the same raw item ID used when the item was indexed.
 */
export const getNeuronItemId = (story) => {
  if (!story || typeof story !== "object") {
    return null;
  }

  for (const field of PRIMARY_UUID_FIELDS) {
    if (!(field in story)) {
      continue;
    }

    const uuid = normaliseStringValue(story[field]);
    if (uuid) {
      return uuid;
    }
  }

  for (const field of SECONDARY_STRING_FIELDS) {
    if (!(field in story)) {
      continue;
    }

    const value = normaliseStringValue(story[field]);
    if (value) {
      return value;
    }
  }

  return null;
};
